module.exports = __webpack_public_path__ + "static/media/boxOnInclinedPlane2.608d8f13.svg";